import { render, staticRenderFns } from "./checkList.vue?vue&type=template&id=63531b50"
import script from "./checkList.vue?vue&type=script&lang=js"
export * from "./checkList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63531b50')) {
      api.createRecord('63531b50', component.options)
    } else {
      api.reload('63531b50', component.options)
    }
    module.hot.accept("./checkList.vue?vue&type=template&id=63531b50", function () {
      api.rerender('63531b50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/checklist/checkList.vue"
export default component.exports